var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InfoField',{attrs:{"label":_vm.label,"hint":_vm.hint,"loading":_vm.loading,"dense":_vm.dense,"invalid":!!_vm.isValid,"message":_vm.isValid ? _vm.isValid: ''}},[_vm._t("inner",function(){return [_vm._v(" "+_vm._s(_vm.value ? _vm.value : _vm.$t('Не задано'))+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }